document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.background-video');

  // Play / Pause toggle on click
  videos.forEach(video => {
    video.addEventListener('click', () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  });

  // Pause automatically when out of viewport
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (video.paused) video.play();
        } else {
          if (!video.paused) video.pause();
        }
      });
    },
    { threshold: 0.25 } // play/pause when 25% visible
  );

  videos.forEach(video => observer.observe(video));
});

document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".background-video");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          // In view → play
          if (video.paused) {
            video.play().catch(() => {}); // prevent errors if browser blocks autoplay
          }
        } else {
          // Out of view → pause
          if (!video.paused) {
            video.pause();
          }
        }
      });
    },
    {
      threshold: 0.25, // play/pause when 25% of video is visible
    }
  );

  videos.forEach((video) => observer.observe(video));
});

